import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52474764"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "departure-date" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_swiper, {
      navigation: "",
      virtual: "",
      initialSlide: _ctx.initialSlide,
      breakpoints: _ctx.breakpoints,
      key: _ctx.initialSlide,
      centeredSlides: true
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDates, (availableDate, index) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: index,
            virtualIndex: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["departure-date__item", {active: _ctx.EEEddMMMyyyy(availableDate.start) === _ctx.date}])
              }, [
                _createElementVNode("label", {
                  for: `${availableDate.start}-${_ctx.DirectionEnum[_ctx.direction]}`
                }, _toDisplayString(_ctx.EEEddMMMyyyy(availableDate.start)), 9, _hoisted_2),
                _withDirectives(_createElementVNode("input", {
                  name: `${_ctx.date}-${_ctx.DirectionEnum[_ctx.direction]}`,
                  id: `${availableDate.start}-${_ctx.DirectionEnum[_ctx.direction]}`,
                  value: _ctx.YYYYMMDD(availableDate.start),
                  type: "radio",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event))
                }, null, 8, _hoisted_3), [
                  [_vModelRadio, _ctx.date]
                ])
              ], 2)
            ]),
            _: 2
          }, 1032, ["virtualIndex"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["initialSlide", "breakpoints"]))
  ]))
}